import { render, staticRenderFns } from "./LowSpaceRating.vue?vue&type=template&id=29adaeb2&scoped=true"
import script from "./LowSpaceRating.vue?vue&type=script&lang=ts"
export * from "./LowSpaceRating.vue?vue&type=script&lang=ts"
import style0 from "./LowSpaceRating.vue?vue&type=style&index=0&id=29adaeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adaeb2",
  null
  
)

export default component.exports